import React, { useEffect } from 'react';
import withAuth from '../../../hocs/withAuth';
import { Row, Col, Container } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchMyBusiness } from '../../../store/actions/business';
import { Package, Tag } from 'lucide-react';

import NavbarBusiness from '../../Components/BusinessNavbar';
import BusinessSidebar from '../../Components/BusinessSidebar';
import ProductForms from '../../Modals/ProductForms';

import './index.css';

const ProductsPage = () => {
	const dispatch = useDispatch();

	const { id } = useSelector((state) => state.currentUser.user);
	const business = useSelector((state) => state.myBusiness);
	const products = business?.products || [];

	useEffect(() => {
		if (id) {
			dispatch(fetchMyBusiness(id));
		}
	}, [dispatch, id]);

	return (
		<div className='business-page-shell'>
			<NavbarBusiness />

			<Row className='g-0 no-gutters'>
				<Col xs='12' md='3' lg='3'>
					<BusinessSidebar />
				</Col>

				<Col xs='12' md='9' lg='9' className='business-page-shell__main'>
					<Container fluid className='products-page'>
						<div className='products-page__header'>
							<div>
								<h1 className='products-page__title'>Products</h1>
								<p className='products-page__subtitle'>
									Manage your product catalog and keep your storefront fresh.
								</p>
							</div>

							<div className='products-page__actions'>
								<ProductForms />
							</div>
						</div>

						<div className='products-page__summary'>
							<div className='products-page__summary-card'>
								<div className='products-page__summary-icon'>
									<Package size={20} />
								</div>
								<div>
									<div className='products-page__summary-value'>
										{products.length}
									</div>
									<div className='products-page__summary-label'>
										Total products
									</div>
								</div>
							</div>
						</div>

						{products.length > 0 ? (
							<Row>
								{products.map((product) => (
									<Col xl='4' lg='6' md='6' sm='12' key={product._id}>
										<div className='product-card'>
											<Link
												to={`/my-product-page/${product._id}`}
												className='product-card__image-link'>
												<div className='product-card__image-wrap'>
													<img
														alt={product.title || 'Product'}
														className='product-card__image'
														src={product.image?.[0]}
													/>
												</div>
											</Link>

											<div className='product-card__body'>
												<div className='product-card__top'>
													<h3 className='product-card__title'>
														{product.title || 'Untitled product'}
													</h3>

													<div className='product-card__price'>
														<Tag size={16} />
														<span>CD$ {product.price}</span>
													</div>
												</div>

												<p className='product-card__description'>
													{product.description || 'No description available.'}
												</p>

												<div className='product-card__footer'>
													<Link
														to={`/my-product-page/${product._id}`}
														className='product-card__link'>
														View product
													</Link>
												</div>
											</div>
										</div>
									</Col>
								))}
							</Row>
						) : (
							<div className='products-page__empty'>
								<div className='products-page__empty-icon'>
									<Package size={28} />
								</div>
								<h3>No products yet</h3>
								<p>
									Create your first product to start building your public
									catalog.
								</p>
								<div className='products-page__empty-action'>
									<ProductForms />
								</div>
							</div>
						)}
					</Container>
				</Col>
			</Row>
		</div>
	);
};

export default withAuth(ProductsPage);
